/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UsersBaseService } from '../users-base-service';
import { UsersApiConfiguration } from '../users-api-configuration';
import { UsersStrictHttpResponse } from '../users-strict-http-response';

import { UsersUserLightDto } from '../models/users-user-light-dto';
import { UsersUserResponseDto } from '../models/users-user-response-dto';
import { usersControllerCreate } from '../fn/users/users-controller-create';
import { UsersControllerCreate$Params } from '../fn/users/users-controller-create';
import { usersControllerFindAllByTenant } from '../fn/users/users-controller-find-all-by-tenant';
import { UsersControllerFindAllByTenant$Params } from '../fn/users/users-controller-find-all-by-tenant';
import { usersControllerFindByStatus } from '../fn/users/users-controller-find-by-status';
import { UsersControllerFindByStatus$Params } from '../fn/users/users-controller-find-by-status';
import { usersControllerFindLightByTenant } from '../fn/users/users-controller-find-light-by-tenant';
import { UsersControllerFindLightByTenant$Params } from '../fn/users/users-controller-find-light-by-tenant';
import { usersControllerFindOne } from '../fn/users/users-controller-find-one';
import { UsersControllerFindOne$Params } from '../fn/users/users-controller-find-one';
import { usersControllerRemove } from '../fn/users/users-controller-remove';
import { UsersControllerRemove$Params } from '../fn/users/users-controller-remove';
import { usersControllerSoftDelete } from '../fn/users/users-controller-soft-delete';
import { UsersControllerSoftDelete$Params } from '../fn/users/users-controller-soft-delete';
import { usersControllerUpdate } from '../fn/users/users-controller-update';
import { UsersControllerUpdate$Params } from '../fn/users/users-controller-update';

@Injectable({ providedIn: 'root' })
export class UsersUsersService extends UsersBaseService {
  constructor(config: UsersApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usersControllerFindAllByTenant()` */
  static readonly UsersControllerFindAllByTenantPath = '/o2-users/users/{tenant}';

  /**
   * Retrieve active users by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindAllByTenant$Response(params: UsersControllerFindAllByTenant$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<Array<UsersUserResponseDto>>> {
    const obs = usersControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve active users by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindAllByTenant(params: UsersControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<UsersUserResponseDto>> {
    const resp = this.usersControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<Array<UsersUserResponseDto>>): Array<UsersUserResponseDto> => r.body)
    );
  }

  /** Path part for operation `usersControllerCreate()` */
  static readonly UsersControllerCreatePath = '/o2-users/users/{tenant}';

  /**
   * Create a new user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerCreate$Response(params: UsersControllerCreate$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersUserResponseDto>> {
    const obs = usersControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerCreate(params: UsersControllerCreate$Params, context?: HttpContext): Observable<UsersUserResponseDto> {
    const resp = this.usersControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersUserResponseDto>): UsersUserResponseDto => r.body)
    );
  }

  /** Path part for operation `usersControllerFindLightByTenant()` */
  static readonly UsersControllerFindLightByTenantPath = '/o2-users/users/{tenant}/light';

  /**
   * Retrieve lightweight users by tenant (for dropdowns/selects).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindLightByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindLightByTenant$Response(params: UsersControllerFindLightByTenant$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<Array<UsersUserLightDto>>> {
    const obs = usersControllerFindLightByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve lightweight users by tenant (for dropdowns/selects).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindLightByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindLightByTenant(params: UsersControllerFindLightByTenant$Params, context?: HttpContext): Observable<Array<UsersUserLightDto>> {
    const resp = this.usersControllerFindLightByTenant$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<Array<UsersUserLightDto>>): Array<UsersUserLightDto> => r.body)
    );
  }

  /** Path part for operation `usersControllerFindByStatus()` */
  static readonly UsersControllerFindByStatusPath = '/o2-users/users/{tenant}/by-status';

  /**
   * Retrieve users by tenant and status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindByStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindByStatus$Response(params: UsersControllerFindByStatus$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<Array<UsersUserResponseDto>>> {
    const obs = usersControllerFindByStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve users by tenant and status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindByStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindByStatus(params: UsersControllerFindByStatus$Params, context?: HttpContext): Observable<Array<UsersUserResponseDto>> {
    const resp = this.usersControllerFindByStatus$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<Array<UsersUserResponseDto>>): Array<UsersUserResponseDto> => r.body)
    );
  }

  /** Path part for operation `usersControllerFindOne()` */
  static readonly UsersControllerFindOnePath = '/o2-users/users/{tenant}/id/{id}';

  /**
   * Retrieve a user by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindOne$Response(params: UsersControllerFindOne$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersUserResponseDto>> {
    const obs = usersControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a user by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindOne(params: UsersControllerFindOne$Params, context?: HttpContext): Observable<UsersUserResponseDto> {
    const resp = this.usersControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersUserResponseDto>): UsersUserResponseDto => r.body)
    );
  }

  /** Path part for operation `usersControllerRemove()` */
  static readonly UsersControllerRemovePath = '/o2-users/users/{tenant}/{id}';

  /**
   * Delete a user by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerRemove$Response(params: UsersControllerRemove$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersUserResponseDto>> {
    const obs = usersControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a user by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerRemove(params: UsersControllerRemove$Params, context?: HttpContext): Observable<UsersUserResponseDto> {
    const resp = this.usersControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersUserResponseDto>): UsersUserResponseDto => r.body)
    );
  }

  /** Path part for operation `usersControllerUpdate()` */
  static readonly UsersControllerUpdatePath = '/o2-users/users/{tenant}/{id}';

  /**
   * Update a user by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerUpdate$Response(params: UsersControllerUpdate$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersUserResponseDto>> {
    const obs = usersControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a user by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerUpdate(params: UsersControllerUpdate$Params, context?: HttpContext): Observable<UsersUserResponseDto> {
    const resp = this.usersControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<UsersUserResponseDto>): UsersUserResponseDto => r.body)
    );
  }

  /** Path part for operation `usersControllerSoftDelete()` */
  static readonly UsersControllerSoftDeletePath = '/o2-users/users/{tenant}/{id}/soft-delete';

  /**
   * Soft delete a user by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerSoftDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerSoftDelete$Response(params: UsersControllerSoftDelete$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<void>> {
    const obs = usersControllerSoftDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Soft delete a user by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerSoftDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerSoftDelete(params: UsersControllerSoftDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.usersControllerSoftDelete$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<void>): void => r.body)
    );
  }

}
